// extracted by mini-css-extract-plugin
export default {"renderer":"_3S9pv"};